export const destinationCountryCookieName = "destinationCountry";
